import { useEffect, useState } from "react";
import { fmtExpected, isExpectedOverdue, toLocalInput, fromLocalInput } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CalendarClock, Loader2 } from "lucide-react";

export function ExpectedDelivery({ order, readOnly, onSave }) {
  const [value, setValue] = useState(toLocalInput(order.expected_at));
  const [busy, setBusy] = useState(false);
  useEffect(() => { setValue(toLocalInput(order.expected_at)); }, [order.expected_at]);

  const overdue = isExpectedOverdue(order);
  const tone = overdue ? "border-red-800 bg-red-950/30 text-red-300" : "border-card2-border bg-appbg-soft/40 text-zinc-200";
  const label = order.expected_at
    ? `${overdue ? "Previsão vencida" : "Previsão de entrega"}: ${fmtExpected(order.expected_at)}`
    : "Previsão de entrega: não informada";

  const save = async (v) => {
    setBusy(true);
    try { await onSave({ expected_at: fromLocalInput(v) }); } catch {} finally { setBusy(false); }
  };

  return (
    <div className={`mt-4 rounded-xl border p-3 ${tone}`} data-testid="expected-delivery">
      <div className="flex items-center gap-2 text-sm font-semibold" data-testid="expected-delivery-text">
        <CalendarClock className="h-4 w-4 shrink-0" /> {label}
      </div>
      {!readOnly && (
        <div className="mt-2 flex flex-col sm:flex-row gap-2">
          <div className="relative sm:max-w-xs flex-1">
            <CalendarClock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500 pointer-events-none" />
            <Input
              data-testid="expected-delivery-input"
              type="datetime-local"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Escolher data e hora"
              style={{ WebkitAppearance: "none", fontSize: 16 }}
              className="bg-zinc-900 border-zinc-800 pl-9 w-full min-w-0 max-w-full block"
            />
          </div>
          <div className="flex gap-2">
            <Button data-testid="expected-delivery-save" type="button" size="sm" disabled={busy || !value} onClick={() => save(value)}
              className="h-10 bg-green-brand hover:bg-green-brandDark font-bold uppercase">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar previsão"}
            </Button>
            {order.expected_at && (
              <Button data-testid="expected-delivery-clear" type="button" size="sm" variant="outline" disabled={busy} onClick={() => save("")}
                className="h-10 bg-zinc-900 border-zinc-800 text-zinc-200 hover:bg-zinc-800">
                Remover
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
